// src/utils/prism.js
// Simple Prism.js setup for syntax highlighting

// Try to use global Prism if available, otherwise create fallback
let Prism;

if (typeof window !== 'undefined' && window.Prism) {
  Prism = window.Prism;
} else {
  // Create a simple fallback for syntax highlighting
  const escapeHtml = (text) => {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const simpleHighlight = (code, language) => {
    const escaped = escapeHtml(code);
    
    // Basic HTML highlighting
    if (language === 'html' || language === 'markup') {
      return escaped
        .replace(/(&lt;\/?)([a-zA-Z][a-zA-Z0-9]*)(.*?)(&gt;)/g, 
          '$1<span style="color: #e06c75;">$2</span>$3$4')
        .replace(/(\s)([a-zA-Z-]+)(=)/g, 
          '$1<span style="color: #d19a66;">$2</span>$3')
        .replace(/(=)(["'])([^"']*)(["'])/g, 
          '$1$2<span style="color: #98c379;">$3</span>$4');
    }
    
    // Basic CSS highlighting
    if (language === 'css') {
      return escaped
        .replace(/([a-zA-Z-]+)(\s*:\s*)/g, 
          '<span style="color: #e06c75;">$1</span>$2')
        .replace(/(:\s*)([^;]+)(;)/g, 
          '$1<span style="color: #98c379;">$2</span>$3')
        .replace(/([.#][a-zA-Z0-9_-]+)/g, 
          '<span style="color: #d19a66;">$1</span>');
    }
    
    // Basic JavaScript highlighting
    if (language === 'javascript' || language === 'js') {
      const keywords = ['const', 'let', 'var', 'function', 'if', 'else', 'for', 'while', 'return', 'import', 'export', 'class'];
      let highlighted = escaped;
      
      keywords.forEach(keyword => {
        const regex = new RegExp(`\\b(${keyword})\\b`, 'g');
        highlighted = highlighted.replace(regex, '<span style="color: #c678dd;">$1</span>');
      });
      
      // Strings
      highlighted = highlighted.replace(/(["'`])([^"'`]*?)(["'`])/g, 
        '$1<span style="color: #98c379;">$2</span>$3');
      
      return highlighted;
    }
    
    return escaped;
  };

  Prism = {
    highlight: simpleHighlight,
    languages: {
      html: {},
      markup: {},
      css: {},
      javascript: {},
      js: {},
      json: {},
      text: {},
      none: {}
    }
  };
}

// Ensure basic languages are available
if (!Prism.languages) {
  Prism.languages = {};
}

// Make Prism available globally
if (typeof window !== 'undefined') {
  window.Prism = Prism;
}

export default Prism;